import { computed, getCurrentInstance, reactive } from 'vue';
export const useRemoteCombobox = data => {
  const { proxy } = getCurrentInstance();

  const comboboxLoadData = async (payload, entityApi, data, name, callBackFn) => {
    if (payload && entityApi) {
      await entityApi.getComboboxPaging(payload).then(result => {
        if (typeof callBackFn == 'function') {
          // bổ sung func cho phép dev custom dữ liệu combo
          result = callBackFn(result, payload);
        }
        data[name] = result;
      });
    }
  };

  const submitQuickAdd = (result, data, name) => {
    if (result && data) {
      if (Array.isArray(result)) {
        data[name] = [...result, ...(data[name] ? data[name] : [])];
      } else {
        data[name] = [...[result], ...(data[name] ? data[name] : [])];
      }
    }
  };

  return { comboboxLoadData, submitQuickAdd };
};
